// extracted by mini-css-extract-plugin
module.exports = {"card":"LoadStatusCard_card__3sgWe"};